export enum InvoiceStatusEnum {
  Paid = 'paid',
  Failed = 'failed',
  Pending = 'pending',
  Credited = 'credited',
}
